import { PlanCode } from '../../interfaces';
import PaymentType from '../../interfaces/EPaymentType';

// Register API Error Codes
const ACTIVE_USER_EXISTS = 'ACTIVE_USER_EXISTS';
const INACTIVE_USER_EXISTS = 'INACTIVE_USER_EXISTS';

const PLAN_CODE = 'planCode';
const ANNUAL_PLAN_CODE: PlanCode = 'fffvipa';
const SEASONAL_PLAN_CODE: PlanCode = 'fffvip';

const CREDIT_CARD = 'CREDIT_CARD';
const PAYPAL = 'PAYPAL';
const APPLE_PAY = 'APPLE_PAY';
const VENMO = 'VENMO';

const paymentTypesDictionary = {
  CREDIT_CARD: PaymentType.CREDIT_CARD,
  PAYPAL: PaymentType.PAYPAL,
  APPLE_PAY: PaymentType.APPLE_PAY,
  VENMO: PaymentType.VENMO,
};

// Segment and trackingh related constants
const ACQUISITION_COMPLETED = 'Acquisition Completed';
const GTB_PURCHASE = 'GTB Purchase';
const INTRO_PURCHASE = 'Intro Product';
const REFILL_PURCHASE = 'Public Sub';

const PURCHASE_PRODUCT_TYPE = {
  gtb: GTB_PURCHASE,
  intro: INTRO_PURCHASE,
  refill: REFILL_PURCHASE,
};

const PURCHASE_EVENT = {
  gtb: {
    event: 'purchase',
    loggerMessage: 'GTB - PURCHASE EVENT',
  },
  intro: {
    event: 'Intro Product Subscribe',
    loggerMessage: 'INTRO PRODUCT - PURCHASE EVENT',
  },
  refill: {
    event: 'Public Subscription Purchase',
    loggerMessage: 'PUBLIC SUBSCRIPTION - PURCHASE EVENT',
  },
};

// Cookie related constants
const COOKIE = {
  key: 'fff_registration_flow',
  value: 'intro-product',
};

// Tracking event names and properties
const FORM_ELEMENT_CLICKED = 'Clicked Element';
const FORM_ENTRY = 'Form Entry';

// Test ids:
const PASSWORD_TOOLTIP_CONTAINER = 'Password ToolTip';

export {
  PLAN_CODE,
  ANNUAL_PLAN_CODE,
  SEASONAL_PLAN_CODE,
  CREDIT_CARD,
  PAYPAL,
  APPLE_PAY,
  VENMO,
  FORM_ELEMENT_CLICKED,
  FORM_ENTRY,
  PASSWORD_TOOLTIP_CONTAINER,
  paymentTypesDictionary,
  PURCHASE_EVENT,
  ACQUISITION_COMPLETED,
  PURCHASE_PRODUCT_TYPE,
  COOKIE,
  ACTIVE_USER_EXISTS,
  INACTIVE_USER_EXISTS,
};
